/**
 * Ko'rinish uchun formatlash. Sof funksiyalar — node:test bilan sinaladi.
 */

/**
 * Sana va deadline yorlig'i ENDI `i18n` da (MultiLang_TZ §8.5, §8.6).
 *
 * Bu yerdan qayta eksport qilinadi, chunki ularni chaqiruvchilar ko'p
 * va bitta o'zgarish bilan hammasi tilga sezgir bo'ldi.
 *
 * Nega ko'chdi: oy nomlari ro'yxati va `n === 1 ? ... : ...` naqshi
 * har bir til uchun takrorlanishi kerak bo'lardi — rus tilida esa
 * ular XATO ishlaydi (21 va 101 `one` shaklini oladi).
 */
export { formatDate, daysLeftLabel } from "./i18n/index.ts";

import { tx } from "./i18n/index.ts";



/** TZ §10.5: 14 kundan kam qolsa qizil. */
export type Urgency = "past" | "urgent" | "soon" | "normal" | "unknown";

export function urgencyOf(days: number | null): Urgency {
  if (days === null) return "unknown";
  if (days < 0) return "past";
  if (days <= 7) return "urgent";
  if (days <= 14) return "soon";
  return "normal";
}

/** ISO 3166-1 alpha-2 -> bayroq emojisi. */
export function flagEmoji(code: string | null): string {
  if (!code || code.length !== 2 || !/^[a-z]{2}$/i.test(code)) return "";
  const base = 0x1f1e6;
  return [...code.toUpperCase()]
    .map((c) => String.fromCodePoint(base + c.charCodeAt(0) - 65))
    .join("");
}


/**
 * Davlat nomi; lug'atda bo'lmasa kodning o'zi.
 *
 * Ro'yxat `i18n/<til>.ts` da (`country.DE`). U yerda turishining
 * sababi oddiy: rus foydalanuvchisiga «Germaniya» emas, «Германия»
 * kerak, va bu matn xarita so'roviga ham tushadi.
 */
export function countryName(code: string | null): string {
  if (!code) return "";
  const upper = code.toUpperCase();
  return tx("country", upper) || upper;
}

/*
 * TYPE_EMOJI olib tashlandi — imkoniyat turlari endi SVG ikonka bilan
 * ko'rsatiladi (icons.tsx: TYPE_ICON). Emoji shriftga bog'liq edi,
 * rangi boshqarilmasdi va dizayn tokenlariga bo'ysunmasdi.
 *
 * Bayroqlar (flagEmoji) QOLDI: ular ma'lumot, ikonka emas — va
 * mamlakat bayrog'ining ma'nosi aynan emoji ko'rinishida.
 */

/*
 * YORLIQLAR LUG'ATGA KO'CHDI (MultiLang_TZ §8.4).
 *
 * Ilgari bu yerda `Record<string, string>` jadvallari turardi va ular
 * FAQAT o'zbekcha edi. Rus interfeysi yoqilganda ekranning yarmi
 * tarjima bo'lib, kartochkadagi «To'liq grant», «Magistratura»,
 * «IELTSsiz» o'zbekcha qolardi — va hech qanday xato chiqmasdi.
 *
 * Qiymatlar SERVERDAN keladi (`funding: "full"`), ya'ni ularni
 * `t()` ning tiplashtirilgan kalitiga aylantirib bo'lmaydi. Shuning
 * uchun `tx(prefiks, qiymat)` ishlatiladi: lug'atda topilmasa
 * qiymatning o'zini qaytaradi.
 */

export const fundingLabel = (v: string | null) => tx("funding", v);
export const levelLabel = (v: string | null) => tx("level", v);
export const formatLabel = (v: string | null) => tx("format", v);
export const fieldLabel = (v: string | null) => tx("field", v);
export const statusLabel = (v: string | null) => tx("status", v);
export const ieltsLabel = (v: string | null) => tx("ielts", v);
export const flagLabel = (v: string | null) => tx("flag", v);

/**
 * Toifa va tez filtr nomi — SERVER MATNI ZAXIRA bilan.
 *
 * `/api/home` va `/api/taxonomy` javobda `label` ham yuboradi, lekin u
 * faqat manba tilida. Shuning uchun avval lug'at qaraladi.
 *
 * Server matni ATAYLAB tashlanmaydi: bazaga yangi toifa qo'shilib,
 * lug'atga yozilmasa, foydalanuvchi `loyiha` kabi ichki kalitni emas,
 * hech bo'lmasa o'zbekcha nomni ko'radi.
 */
export function typeLabel(key: string, serverLabel?: string): string {
  const own = tx("type", key);
  return own === key ? serverLabel || key : own;
}

export function quickLabel(key: string, serverLabel?: string): string {
  const own = tx("quick", key);
  return own === key ? serverLabel || key : own;
}

/*
 * KALIT RO'YXATLARI — yorliq emas, TARTIB va TO'PLAM.
 *
 * Onboarding va filtrlar variantlar ro'yxatini shu yerdan quradi.
 * Ilgari ular `Object.keys(STATUS_LABEL)` bilan olinardi, ya'ni
 * ro'yxat yorliq jadvaliga bog'liq edi. Yorliqlar lug'atga ko'chgach
 * bu bog'liqlik uzildi: lug'atda kalitlar boshqa tartibda turishi
 * mumkin va u yerga yangi til qo'shilganda tartib jimgina
 * o'zgarishi mumkin edi.
 */
export const STATUS_KEYS = [
  "maktab", "bakalavr_talaba", "bakalavr_tugagan",
  "magistr_talaba", "magistr_tugagan", "ishlayapti",
] as const;

export const FIELD_KEYS = [
  "it", "stem", "medicine", "business", "law",
  "arts", "social", "education", "agriculture", "any",
] as const;

export const IELTS_KEYS = ["yes", "no", "preparing"] as const;

/**
 * Kartada ko'rsatiladigan bayroqchalar (TZ §10.5, 4-punkt).
 *
 * Bu RO'YXAT, yorliq emas: `activeFlags()` qaysi bayroqlar borligini
 * bilishi kerak va tartib ham shu yerdan keladi. Matnlar esa
 * lug'atda (`flag.no_ielts` va h.k.).
 */
export const FLAG_KEYS = [
  "no_ielts", "no_experience", "no_fee", "women_only", "is_paid_position",
] as const;

export function activeFlags(flags: Record<string, unknown>): string[] {
  return FLAG_KEYS.filter((key) => flags[key] === true);
}
